import { Pipe, PipeTransform } from '@angular/core';

const localizationDictionary: { [code: string]: string } = {
  INVALID_JWT_CANT_VERIFY_SIGNATURE: 'This link is invalid',
  INVALID_JWT_ASSIGNEE_CHANGED: 'You are no longer the assignee for this task',
  INVALID_JWT_LINK_IS_EXPIRED: 'This link has expired',
  INVALID_JWT_TURN_CANCELLED: 'This turn was cancelled',
  INVALID_JWT_TURN_COMPLETED: 'This turn is no longer on the board',
  INVALID_JWT_BOARD_COMPLETED: 'This turn is no longer on the board',
  INVALID_JWT_STEP_WAS_NOT_FOUND: 'This task no longer exists',
  INVALID_JWT_CANT_VERIFY_ISSUER: 'Your link is not valid',
};

@Pipe({
  name: 'translateCode',
  standalone: true,
})
export class TranslateCodePipe implements PipeTransform {
  transform(code: string, ...values): string {
    let localizedText = localizationDictionary[code] ?? code;
    if (values) {
      values.forEach((v, i) => (localizedText = localizedText.replace(new RegExp(`\\{${i}\\}`, 'g'), v)));
    }
    return localizedText;
  }
}
